import { format } from 'date-fns'
import type { SearchWithExtras, Trivia } from 'generated/api'
import { ensureDate } from 'lib/undefinedHelpers/dates'

/**
 * Ensures trivia is not undefined, and adds date trivia if desired
 * @param search
 * @param addSearchDate
 */
export const sanitizeTrivia = (search?: SearchWithExtras, addSearchDate = true): Array<Trivia> => {
	const searchTrivia = search?.summary?.trivia
	const prefix: Array<Trivia> = []

	if (addSearchDate && search?.created) {
		prefix.push({
			importance: 0,
			key: 'search-date',
			title: 'Search Date',
			value: format(ensureDate(search?.created), 'MMM do')
		})
	}
	if (searchTrivia) {
		return [...prefix, ...searchTrivia]
	}
	return []
}

/**
 * UI enum for display decisions
 */
export enum SearchType {
	loading = 'loading', // Show Skeleton
	legacy = 'legacy', // know we dont have all the info, custom buttons
	inProgress = 'inProgress', // not executed yet, show in progress style
	noOffers = 'noOffers', // show explore search button
	expired = 'expired', // grey out, custom CTA
	hasActiveOffers = 'activeOffers', // the good one
	error = 'error' // the bad one
}

/**
 * Determines the high level state of the search which
 * apply to a number of styles, rather than creating many inline forks.
 * @param search
 */
export const determineSearchType = (search?: SearchWithExtras): SearchType => {
	const offerCount = search?.summary?.offerCount || 0

	if (!search) {
		return SearchType.loading
	} else if (search?.executed === false) {
		return SearchType.inProgress
	} else if (search.summary?.status === 'expired') {
		return SearchType.expired
	} else if (search.summary?.legacyView) {
		return SearchType.legacy
	} else if (offerCount === 0) {
		return SearchType.noOffers
	} else if (offerCount > 0) {
		return SearchType.hasActiveOffers
	}

	return SearchType.error
}
